export default ({ fill = "white", size = "16" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4397 14.7706L11.2505 10.5814C12.1742 9.50379 12.71 8.10939 12.71 6.57879C12.71 3.17715 9.95291 0.420898 6.55215 0.420898C3.1514 0.420898 0.420898 3.17804 0.420898 6.57879C0.420898 9.97955 3.17775 12.7367 6.55215 12.7367C8.08215 12.7367 9.47863 12.1754 10.5548 11.252L14.7439 15.4411C14.8624 15.5314 14.9837 15.5788 15.1051 15.5788C15.2265 15.5788 15.3475 15.5325 15.4399 15.44C15.6262 15.2561 15.6262 14.9541 15.4397 14.7706ZM6.5788 11.7893C3.68044 11.7893 1.36827 9.4505 1.36827 6.57879C1.36827 3.70708 3.68044 1.36827 6.5788 1.36827C9.47715 1.36827 11.7893 3.68044 11.7893 6.57879C11.7893 9.47715 9.45051 11.7893 6.5788 11.7893Z"
      fill={fill}
    />
  </svg>
);
